import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { VirtualChannelStoreEffects } from './effects';
import { virtualChannelReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('virtualChannel', virtualChannelReducer),
    EffectsModule.forFeature([VirtualChannelStoreEffects]),
  ],
})
export class VirtualChannelStoreModule {}
